import { createFileRoute } from '@tanstack/react-router';
import { FieldPurchasesPage } from '@/features/purchasing/FieldPurchases';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/field')({
  component: FieldPurchasesPage,
});
